import React, { useState } from 'react';
import { Button, Card, Col, Form, InputGroup, Modal, Row } from 'react-bootstrap';
import { useForm } from '../../hooks/useForm';
import { fetchConToken } from '../../api/fetch';
import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai';
import { useContextInfo } from '../../context/ContextInfo';

const ModRouter = ({ show, onHide, callBk }) => {
    const [loading, setLoading] = useState(false);
    const [validated, setValidated] = useState(false);

    const [type, setType] = useState('password');
    const { setResp } = useContextInfo();

    const [values, handleInputChange, reset] = useForm({
        nodo: '',
        ip: '',
        user: '',
        pass: '',
        port_api: '',
    });
    const onSubmit = async (e) => {
        e.preventDefault();
        if (loading) return;
        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            setValidated(true);
        } else {
            setLoading(true);
            const res = await fetchConToken('networks/addmktik', values, 'POST');
            if (res) setLoading(false);
            setResp(res);
            callBk();
            reset();
            onHide();
        }
    };
    return (
        <Modal show={show} onHide={onHide} size="kg">
            <Modal.Header onHide={onHide} closeButton>
                <h4 className="modal-title">Nuevo router</h4>
            </Modal.Header>
            <Modal.Body>
                <>
                    <Row>
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Form noValidate validated={validated} onSubmit={onSubmit}>
                                        <Form.Group className="mb-3" controlId="validationCustom01">
                                            <Form.Label>Nombre</Form.Label>
                                            <Form.Control
                                                required
                                                type="text"
                                                placeholder="Router"
                                                value={values.nodo}
                                                name="nodo"
                                                onChange={handleInputChange}
                                            />
                                            <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                        </Form.Group>{' '}
                                        <Form.Group className="mb-3" controlId="validationCustom02">
                                            <Form.Label>Ip</Form.Label>
                                            <Form.Control
                                                required
                                                type="text"
                                                placeholder="Ip"
                                                value={values.ip}
                                                name="ip"
                                                onChange={handleInputChange}
                                            />
                                        </Form.Group>
                                        <Form.Control.Feedback>Válido</Form.Control.Feedback>{' '}
                                        <Form.Group className="mb-3" controlId="validationCustom02">
                                            <Form.Label>Puerto api</Form.Label>
                                            <Form.Control
                                                required
                                                type="number"
                                                placeholder="8728"
                                                value={values.port_api}
                                                name="port_api"
                                                onChange={handleInputChange}
                                                maxLength={4}
                                            />
                                        </Form.Group>
                                        <Form.Control.Feedback>Válido</Form.Control.Feedback>{' '}
                                        <Form.Group className="mb-3" controlId="validationCustom07">
                                            <Form.Label>Usuario</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="user"
                                                required
                                                value={values.user}
                                                onChange={handleInputChange}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                Ingrese un usuario
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group className="mb-3" controlId="validationCustom08">
                                            <Form.Label>Contraseña</Form.Label>
                                            <InputGroup hasValidation>
                                                <InputGroup.Text id="inputGroupPrepend">
                                                    {type === 'password' ? (
                                                        <AiFillEye onClick={() => setType('text')} />
                                                    ) : (
                                                        <AiFillEyeInvisible onClick={() => setType('password')} />
                                                    )}
                                                </InputGroup.Text>
                                                <Form.Control
                                                    type={type}
                                                    name="pass"
                                                    value={values.pass}
                                                    onChange={handleInputChange}
                                                    required
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    Ingrese una Contraseña
                                                </Form.Control.Feedback>{' '}
                                            </InputGroup>
                                        </Form.Group>
                                        <Button type="submit">Guardar</Button>
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </>
            </Modal.Body>
        </Modal>
    );
};

export default ModRouter;
